import { apiFetch, apiUpload } from '@/lib/api';
import type { FlyerDocument, FlyerDocumentInput } from '@/types/flyerDoc';

const D = '/flyer-composer/documents';

export const listFlyerDocs = () => apiFetch<FlyerDocument[]>(D);
export const getFlyerDoc = (id: string) => apiFetch<FlyerDocument>(`${D}/${encodeURIComponent(id)}`);
export const createFlyerDoc = (b: FlyerDocumentInput) =>
  apiFetch<FlyerDocument>(D, { method: 'POST', body: JSON.stringify(b) });
export const updateFlyerDoc = (id: string, b: FlyerDocumentInput) =>
  apiFetch<FlyerDocument>(`${D}/${encodeURIComponent(id)}`, { method: 'PUT', body: JSON.stringify(b) });
export const deleteFlyerDoc = async (id: string) => {
  await apiFetch(`${D}/${encodeURIComponent(id)}`, { method: 'DELETE' });
};

// owner_type='flyer_doc' hits the admin-required branch of /attachments and
// returns the React wire shape { id: <uuid>, url, ... }.
export const uploadDocAttachment = (docId: string, file: File | Blob, attachmentType: 'background' | 'element' | 'export', filename = 'file.png') => {
  const fd = new FormData();
  fd.append('file', file, file instanceof File ? file.name : filename);
  fd.append('owner_type', 'flyer_doc');
  fd.append('owner_id', docId);
  fd.append('attachment_type', attachmentType);
  return apiUpload<{ id: string; url: string }>('/attachments', fd);
};

export const importPrototype = (docId: string, url: string) =>
  apiFetch<FlyerDocument>(`${D}/${encodeURIComponent(docId)}/prototype`, {
    method: 'POST', body: JSON.stringify({ url }),
  });

export const getLinkPreview = (url: string) =>
  apiFetch<{ url: string }>(`/flyer-composer/link-preview?url=${encodeURIComponent(url)}`);
